/**
 * Utility functions for displaying and formatting account data in drilldowns
 */

// In future from generic type of
// type Maybe<T> = T | undefined | null
// Useful type for registering per data fragment formatters
// type DataDisplayFormatter<T> = (data: T) => string;
// type DataListDisplayFormatter<T> = (data: Maybe<T[]>) => string

export type Maybe<T> = T | undefined | null;

export interface AccountData {
  id: string;
  name: string;
  source_record_id?: string;
}

export type AccountDataListFormatter = (data: Maybe<AccountData[]>) => string;

/**
 * Format accounts array for CSV export
 * Returns comma-separated list of quoted account names
 */
export const formatAccountsForCSV: AccountDataListFormatter = (
  accounts,
): string => {
  if (!accounts || accounts.length === 0) {
    return "";
  }

  return accounts
    .map((account) => `"${account.name.replace(/"/g, '""')}"`)
    .join(", ");
};

/**
 * Format account source record IDs for CSV export
 * Returns comma-separated list of source record IDs
 */
export const formatAccountSourceRecordIdsForCSV: AccountDataListFormatter = (
  accounts,
): string => {
  if (!accounts || accounts.length === 0) {
    return "";
  }

  return accounts
    .map((account) => account.source_record_id || "")
    .filter((id) => id !== "")
    .join(", ");
};
